import React from 'react';
import PropTypes from 'prop-types';

const PrintIcon = ({ isActive }) => {
    const activeColor = isActive ? '#007BCE' : '#BBC6D4';

    return (
        <svg style={{ cursor: isActive ? 'pointer' : 'not-allowed' }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g id="Icons">
                <path id="Subtract" fillRule="evenodd" clipRule="evenodd" d="M3 7H21C21.5523 7 22 7.44771 22 8V15C22 15.5523 21.5523 16 21 16H20V17H21C22.1046 17 23 16.1046 23 15V8C23 6.89543 22.1046 6 21 6H3C1.89543 6 1 6.89543 1 8V15C1 16.1046 1.89543 17 3 17H4V16H3C2.44772 16 2 15.5523 2 15V8C2 7.44772 2.44772 7 3 7Z" fill={activeColor} />
                <path id="Rectangle 115" d="M5.5 1C5.5 0.723858 5.72386 0.5 6 0.5H18C18.2761 0.5 18.5 0.723858 18.5 1V6.5H5.5V1Z" stroke={activeColor} />
                <rect id="Rectangle 116" x="5.5" y="14.5" width="13" height="8" stroke={activeColor} />
                <line id="Line 45" x1="7" y1="17.5" x2="17" y2="17.5" stroke={activeColor} />
                <line id="Line 46" x1="7" y1="19.5" x2="17" y2="19.5" stroke={activeColor} />
                <circle id="Ellipse 80" cx="3.5" cy="8.5" r="0.5" fill={activeColor} />
                <circle id="Ellipse 81" cx="5.5" cy="8.5" r="0.5" fill={activeColor} />
                <circle id="Ellipse 82" cx="7.5" cy="8.5" r="0.5" fill={activeColor} />
            </g>
        </svg>
    );
};

PrintIcon.propTypes = {
    isActive: PropTypes.bool,
};
PrintIcon.defaultProps = {
    isActive: false,
};

export default PrintIcon;
